import React from "react";
import { LEGAL_COOKIES_URL } from "../config/legalUrls";
import LegalMarketingRedirect from "./LegalMarketingRedirect";

const CookiePolicyPage = () => (
  <LegalMarketingRedirect url={LEGAL_COOKIES_URL} testId="cookie-policy-page" />
);

export default CookiePolicyPage;
